"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AcPdfEditorStampMenu_1 = require("./sideSubMenus/AcPdfEditorStampMenu");
var AcPdfDateStampMenu_1 = require("./sideSubMenus/AcPdfDateStampMenu");
var AcPdfSetPhraseMenu_1 = require("./sideSubMenus/AcPdfSetPhraseMenu");
var AcButton_1 = require("../button/AcButton");
var SaveAndClose_1 = require("./modals/SaveAndClose");
exports.AcPdfEditorSideMenuContext = react_1.default.createContext({});
exports.AcPdfEditorSideMenu = function (_a) {
    var faxDocument = _a.faxDocument, sendEditedFax = _a.sendEditedFax, handleCancel = _a.handleCancel, onCreateDraft = _a.onCreateDraft;
    var _b = react_1.useState('stampMenu'), activeMenu = _b[0], setActiveMenu = _b[1];
    var _c = react_1.useState(false), disableButtons = _c[0], setDisableButtons = _c[1];
    var _d = react_1.useState(false), showSaveAndCloseModal = _d[0], setShowSaveAndCloseModal = _d[1];
    var renderStampMenu = function () {
        switch (activeMenu) {
            case 'stampMenu':
                return react_1.default.createElement(AcPdfEditorStampMenu_1.AcPdfEditorStampMenu, null);
            case 'dateStampMenu':
                return react_1.default.createElement(AcPdfDateStampMenu_1.AcPdfDateStampMenu, null);
            case 'phraseMenu':
                return react_1.default.createElement(AcPdfSetPhraseMenu_1.AcPdfSetPhraseMenu, null);
            default:
                return null;
        }
    };
    var onClickCreateFax = function () { return __awaiter(void 0, void 0, void 0, function () {
        var passInChargeCheck;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // API call save and send
                    setDisableButtons(true);
                    if (!sendEditedFax) return [3 /*break*/, 2];
                    return [4 /*yield*/, sendEditedFax()];
                case 1:
                    passInChargeCheck = _a.sent();
                    if (!passInChargeCheck) {
                        setDisableButtons(false);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var showSubmit = activeMenu !== 'dateStampMenu' && activeMenu !== 'phraseMenu';
    var onClickSaveAndClose = function () {
        // API call direct save and close
        setShowSaveAndCloseModal(true);
    };
    var bottomButtons = (react_1.default.createElement("div", { className: "d-flex" },
        react_1.default.createElement(AcButton_1.AcButton, { variant: "apzlightblue", onClick: onClickSaveAndClose, disabled: disableButtons, block: true, className: "mt-auto", height: "90" },
            react_1.default.createElement("span", { className: "flex-grow-1 text-apzlinkblue" }, "\u4FDD\u5B58\u3057\u3066\u7D42\u4E86")),
        react_1.default.createElement(AcButton_1.AcButton, { variant: "cloudLink", onClick: onClickCreateFax, disabled: disableButtons, block: true, className: "mt-auto", height: "90" },
            react_1.default.createElement("div", { className: "d-flex flex-row align-items-center" },
                react_1.default.createElement("span", { className: "flex-grow-1" },
                    "\u4FDD\u5B58\u3057\u3066",
                    react_1.default.createElement("br", null),
                    "FAX\u9001\u4FE1\u8A2D\u5B9A\u3078"),
                react_1.default.createElement("i", { className: "fas fa-arrow-right fa-fw fs-18" }))),
        react_1.default.createElement(SaveAndClose_1.SaveAndClose, { initalNote: faxDocument === null || faxDocument === void 0 ? void 0 : faxDocument.note1, show: showSaveAndCloseModal, closeSaveAndClose: function () { return setShowSaveAndCloseModal(false); }, closePdfEditor: handleCancel, onCreateDraft: onCreateDraft })));
    return (react_1.default.createElement(exports.AcPdfEditorSideMenuContext.Provider, { value: { activeMenu: activeMenu, setActiveMenu: setActiveMenu } },
        react_1.default.createElement("div", { className: "position-fixed bg-white h-100 d-flex flex-column", style: { width: '375px', top: '0', right: '0', left: 'auto' } },
            react_1.default.createElement("div", { className: "pl-6 pt-6 pr-3 pb-6 flex-grow-1 overflow-auto" }, renderStampMenu()),
            showSubmit && bottomButtons)));
};
exports.AcPdfEditorSideMenu.displayName = 'AcPdfEditorSideMenu';
//# sourceMappingURL=AcPdfEditorSideMenu.js.map